import React, { useEffect, useState } from 'react';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

import CalculationResult from '../calculation-result/CalculationResult';
import DescriptionValue from '../description-value/DescriptionValue';
import SliderRow from '../slider-row/SliderRow';
import InputRow from '../input-row/InputRow';

import {
    Modal,
    ModalDialog,
    ModalColumn,
    ModalContent,
    DescriptionRow,
    CloseButtonBlack,
    CloseButtonWhite,
} from './style';
import { Column } from '../../style';

import close_white from '../../assets/close_white.svg';
import close_black from '../../assets/close_black.svg';

const ModalCalculator = ({ open, onClose }) => {
    const [sliderValue0, setSliderValue0] = useState(40);
    const [sliderValue1, setSliderValue1] = useState(6.5);
    const [sliderValue2, setSliderValue2] = useState(165);
    const [sliderValue3, setSliderValue3] = useState(11);
    const [sliderValue4, setSliderValue4] = useState(3);
    const [sliderValue5, setSliderValue5] = useState(5);
    const [inBound, setInbound] = useState('80%');
    const [outBound, setOutbound] = useState('20%');
    const [mobile, setMobile] = useState('70%');
    const [metro, setMetro] = useState('30%');
    const [activeIndex, setActiveIndex] = useState(-1);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        if (open) {
            setTimeout(() => setAnimate(true), 0);
        } else {
            setAnimate(false);
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onMouseDown={(event) => {
                if (event.target.getAttribute('role') === 'dialog') {
                    onClose();
                }
            }}
            role='dialog'
        >
            <ModalDialog>
                <ModalContent animate={animate}>
                    <ModalColumn
                        flex='0.7'
                        padding='12px 48px'
                        borderRadius='20px 0 0 20px'
                        colors={['#F9F9F9', '#F9F9F9']}
                    >
                        <Column>
                            <CloseButtonBlack src={close_black} alt='' onClick={onClose}/>
                            <DescriptionValue
                                isActive={activeIndex === 0}
                                text='How many full time agents do you have?'
                                value={sliderValue0}
                                min={0}
                                max={1000}
                                step={1}
                                changeValue={(value) => setSliderValue0(value)}
                                changeIndex={() => setActiveIndex(0)}
                                type='number'
                            />
                            <SliderRow
                                min={0}
                                max={1000}
                                isActive={activeIndex === 0}
                                value={sliderValue0}
                                changeValue={(value) => {
                                    setSliderValue0(value);
                                    setActiveIndex(0);
                                }}
                            />
                        </Column>
                        <DescriptionRow>
                            Industry average data below (adjust if required)
                        </DescriptionRow>
                        <Column>
                            <DescriptionValue
                                isActive={activeIndex === 1}
                                text='Avg hours per day agent in ready/occupied state'
                                value={sliderValue1}
                                min={0}
                                max={10}
                                step={0.5}
                                changeValue={(value) => setSliderValue1(value)}
                                changeIndex={() => setActiveIndex(1)}
                                type='decimal'
                            />
                            <SliderRow
                                min={0}
                                max={10}
                                step={0.5}
                                isActive={activeIndex === 1}
                                value={sliderValue1}
                                changeValue={(value) => {
                                    setSliderValue1(value);
                                    setActiveIndex(1);
                                }}
                            />
                        </Column>
                        <Column>
                            <DescriptionValue
                                isActive={activeIndex === 9}
                                text='Average talk time per day (hours)'
                                value={sliderValue5}
                                min={0}
                                max={8}
                                step={1}
                                changeValue={(value) => setSliderValue5(value)}
                                changeIndex={() => setActiveIndex(9)}
                                type='number'
                            />
                            <SliderRow
                                min={0}
                                max={8}
                                step={1}
                                isActive={activeIndex === 9}
                                value={sliderValue5}
                                changeValue={(value) => {
                                    setSliderValue5(value);
                                    setActiveIndex(9);
                                }}
                            />
                        </Column>
                        <Column>
                            <DescriptionValue
                                isActive={activeIndex === 2}
                                text='Industry avg platform license cost agent/month'
                                value={sliderValue2}
                                number={sliderValue2}
                                min={0}
                                max={500}
                                step={1}
                                changeValue={(value) => setSliderValue2(value)}
                                changeIndex={() => setActiveIndex(2)}
                                type='dollar'
                            />
                            <SliderRow
                                min={0}
                                max={500}
                                isActive={activeIndex === 2}
                                value={sliderValue2}
                                changeValue={(value) => {
                                    setSliderValue2(value);
                                    setActiveIndex(2);
                                }}
                            />
                        </Column>
                        <Column>
                            <DescriptionValue
                                isActive={activeIndex === 3}
                                text='Industry avg absenteeism per month'
                                value={sliderValue3}
                                min={0}
                                max={50}
                                step={1}
                                changeValue={(value) => setSliderValue3(value)}
                                changeIndex={() => setActiveIndex(3)}
                                type='percent'
                            />
                            <SliderRow
                                min={0}
                                max={50}
                                isActive={activeIndex === 3}
                                value={sliderValue3}
                                changeValue={(value) => {
                                    setSliderValue3(value);
                                    setActiveIndex(3);
                                }}
                            />
                        </Column>
                        <Column>
                            <InputRow
                                activeIndex={activeIndex}
                                changeIndex={(index) => setActiveIndex(index)}
                                inBound={inBound}
                                outBound={outBound}
                                mobile={mobile}
                                metro={metro}
                                changeInBound={(value) => setInbound(value)}
                                changeOutBound={(value) => setOutbound(value)}
                                changeMobile={(value) => setMobile(value)}
                                changeMetro={(value) => setMetro(value)}
                            />
                        </Column>
                        <Column>
                            <DescriptionValue
                                isActive={activeIndex === 4}
                                text='Average time on phone (minutes)'
                                value={sliderValue4}
                                min={0}
                                max={10}
                                step={0.5}
                                changeValue={(value) => setSliderValue4(value)}
                                changeIndex={() => setActiveIndex(4)}
                                type='decimal'
                            />
                            <SliderRow
                                min={0}
                                max={10}
                                step={0.5}
                                isActive={activeIndex === 4}
                                value={sliderValue4}
                                changeValue={(value) => {
                                    setSliderValue4(value);
                                    setActiveIndex(4);
                                }}
                            />
                        </Column>
                    </ModalColumn>
                    <ModalColumn
                        flex='0.3'
                        padding='24px 24px'
                        borderRadius='0 20px 20px 0'
                        colors={['#1D22FD', '#09CFFD']}
                    >
                        <CloseButtonWhite src={close_white} alt='' onClick={onClose}/>
                        <CalculationResult
                            sliderValue0={sliderValue0}
                            sliderValue1={sliderValue1}
                            sliderValue2={sliderValue2}
                            sliderValue3={sliderValue3}
                            sliderValue4={sliderValue4}
                            sliderValue5={sliderValue5}
                            inBound={inBound.includes('%') ? +inBound.slice(0, -1) / 100 : inBound / 100}
                            outBound={outBound.includes('%') ? +outBound.slice(0, -1) / 100 : outBound / 100}
                            mobile={mobile.includes('%') ? +mobile.slice(0, -1) / 100 : mobile / 100}
                            metro={metro.includes('%') ? +metro.slice(0, -1) / 100 : metro / 100}
                            onClose={() => onClose()}
                        />
                    </ModalColumn>
                </ModalContent>
            </ModalDialog>
        </Modal>
    )
};

export default ModalCalculator;
